import { Filter } from '@/interfaces/filter.interface'
import { APIMenu } from '@/models/api/menu.model'
import { MenuServices } from '@/services/modules/menu.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class MenuStore extends VuexModule {
    menu: object[] = []
    menuPaginate: object[] = []
    menuForm: object|null = null
    menuUser: object[] = []

    @Mutation
    updateMenus (newMenus: object[]) {
        this.menu = newMenus
    }

    @Mutation
    updateMenusPaginate (newMenus: object[]) {
        this.menuPaginate = newMenus
    }

    @Mutation
    updateMenu (newMenu: object) {
        this.menuForm = newMenu
    }

    @Mutation
    updateMenuUser (newMenuUser: object[]) {
        this.menuUser = newMenuUser
    }

    @Action
    getMenu () {
        return new Promise((resolve) => {
            MenuServices.getMenu()
                .then(resp => {
                    store.commit('updateMenus', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getMenuPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            MenuServices.getMenuPaginate(newParams)
                .then(resp => {
                    store.commit('updateMenusPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getMenuById (id: number) {
        return new Promise((resolve) => {
            MenuServices.getMenuById(id)
                .then(resp => {
                    store.commit('updateMenu', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createMenu (params: APIMenu) {
        params = new APIMenu(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIMenu)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            MenuServices.createMenu(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editMenu (params: APIMenu) {
        delete params.menuItems

        params.id = params.menuId

        params = new APIMenu(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIMenu)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            MenuServices.editMenu(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteMenu (id: number) {
        return new Promise((resolve) => {
            MenuServices.deleteMenu(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
